module.exports = __webpack_public_path__ + "static/Graphik-Regular-Web-636c0665ca600257380f7b9c369c679e.woff2";